import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useActiveForm } from '@/components/form/ActiveSwitch';
import { useAppAlert } from '@Components/AppAlert';
import FormWrapper from '@Components/form/Wrapper';
import Version from 'components/modals/Version';
import history from 'utils/history';

import Form from '../components/Form';
import Heading from '../components/Heading';
import { PageProvider, usePageStore } from '../store';

const propTypes = {
  match: PropTypes.object,
}

const PageForm = () => {
  const { id } = useParams()
  const [isVersionView, setIsVersionView] = useState(false)
  const [restored, setRestored] = useState(false)
  const [viewClosed, setViewClosed] = useState(false)
  const [data, setData] = useState(null)
  const { collection: { item, useLoad, useSubmit, reset }, getVersions } = usePageStore()
  const { handleSuccess, handleError } = useAppAlert()
  const { active, setActive } = useActiveForm(item)

  useEffect(() => {
    setData(Object.keys(item || {}).length ? { ...item } : null)
  }, [item])

  const loadData = useLoad(id)
  const handleSubmit = useSubmit()

  const handleSubmitAndRedirect = useCallback(async (payload, newVersion) => {
    try {
      const { id } = await handleSubmit({ ...payload, newVersion, active })
      if (payload.id) {
        reset()
        await loadData()
      } else {
        reset()
        history.push(`./${id}`)
      }
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Page ${message}.`)
    } catch (error) {
      handleError('Error', 'Page was not saved.')
    }
  }, [handleSubmit, reset, loadData, handleSuccess, handleError, active])

  const openView = useCallback(versionData => {
    if (typeof versionData.integrationData === 'string') {
      versionData.integrationData = JSON.parse(versionData.integrationData)
    }
    setIsVersionView(true)
    setViewClosed(true)
    setData({ ...versionData })
  }, [])

  const closeView = useCallback(restored => {
    setIsVersionView(false)
    setViewClosed(!restored)
    setRestored(restored || false)
    setData(restored ? data : item)
  }, [data, item])

  const handleCloseView = useCallback(restored => () => {
    closeView(restored)
  }, [closeView])

  const handleView = useCallback(data => {
    if (data) return openView(data)
    return closeView()
  }, [openView, closeView])

  return <>
    <FormWrapper title="Page">
      <div key={data ? data.id : 0}>
        <Heading data={data} active={active} onChangeActive={setActive} disabled={isVersionView} >
          {data && <Version loadVersions={() => getVersions(data.id)} onView={handleView} number={data.version} />}
        </Heading>
        <Form data={data} viewClosed={viewClosed} handleSubmit={handleSubmitAndRedirect} onCloseView={isVersionView && handleCloseView} restored={restored} />
      </div>
    </FormWrapper>
  </>
};

PageForm.propTypes = propTypes

export default function PageFormLayout() {
  return <PageProvider>
    <PageForm />
  </PageProvider>
}
